import * as React from 'react'

const PdfIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <g id="SVGRepo_iconCarrier">
        <g
          id="Page-1"
          fill="none"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
          {...props}
          ref={ref}
        >
          <g id="add" fill="#000" transform="translate(85.333 42.667)">
            <path
              id="document-pdf"
              d="M75.947 285.653a61 61 0 0 0-40.32-8.32H0v128h28.373V356.48h12.16a55.04 55.04 0 0 0 35.84-8.747 38.61 38.61 0 0 0 13.44-30.933 37.33 37.33 0 0 0-13.866-31.147m-22.827 46.72a32.85 32.85 0 0 1-17.067 2.56h-8.32v-36.266h8.32a30.3 30.3 0 0 1 17.494 3.413 17.49 17.49 0 0 1 7.466 15.36 15.15 15.15 0 0 1-7.893 14.933m97.707-55.04h-35.414v128h33.92a90.24 90.24 0 0 0 50.134-9.6 60.16 60.16 0 0 0 23.893-54.4 64 64 0 0 0-17.707-48.853 73.39 73.39 0 0 0-54.826-15.147m28.16 98.987a51.2 51.2 0 0 1-29.227 6.4h-5.547v-82.773h5.12c17.92 0 24.96 1.706 32 8.106a43.95 43.95 0 0 1 12.16 33.28 41.39 41.39 0 0 1-14.506 34.987m75.52 29.013h28.8v-53.546h58.026v-22.614h-58.026v-29.226h58.026v-22.614h-86.826zM234.667 0H0v234.667h42.667v-192H216.96l81.707 81.706v110.294h42.666v-128z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
)

PdfIcon.displayName = 'PdfIcon'

export { PdfIcon }
